import { useSelector } from "react-redux";
import styles from "../../../styles/Components/new-dashboard/bot-performance/BotOverallPerformance.module.css";

function BotOverallPerformance() {
  const {
    dashboard: { botInfo, overallBotPerformance },
  } = useSelector((state) => state);

  const { number_of_bots: botsNum, active_bots: activeBots } = botInfo;

  const {
    overall_performance: {
      num_successful_trades: totalSuccessful,
      total_trades_processed: totalTrades,
      win_rate: winRate,
      profit_percent: profit,
      balance_date_list: balanceDates,
      balance_lists: balanceLists,
    } = {},
    status,
    message,
  } = overallBotPerformance;

  return (
    <div className={styles.container}>
      <h6>All Bots Performance</h6>
      {status !== "ok" ? (
        <p>{message}</p>
      ) : (
        <>
          <ul className={styles.infoList}>
            <li className={styles.infoItem}>
              <strong>{botsNum}</strong> <span>Total Bots</span>
            </li>
            <li className={styles.infoItem}>
              <strong>{activeBots}</strong> <span>Active Bots</span>
            </li>
            <li className={styles.infoItem}>
              <strong>{totalSuccessful}</strong> <span>Successful Trades</span>
            </li>
            <li className={styles.infoItem}>
              <strong>{totalTrades}</strong> <span>Total Trades</span>
            </li>
            <li className={styles.infoItem}>
              <strong>{winRate}</strong> <span>Win Rate</span>
            </li>
            <li className={styles.infoItem}>
              <strong>{profit}%</strong> <span>Profit</span>
            </li>
          </ul>
          {/*<BotPerformanceChart*/}
          {/*  balanceLists={balanceLists}*/}
          {/*  balanceDateList={balanceDates}*/}
          {/*/>*/}
        </>
      )}
    </div>
  );
}

export default BotOverallPerformance;
